var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupMicOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 1.33301C6.52728 1.33301 5.33338 2.52691 5.33338 3.99967V7.33301C5.33338 8.80577 6.52728 9.99967 8.00004 9.99967C9.4728 9.99967 10.6667 8.80577 10.6667 7.33301V3.99967C10.6667 2.52692 9.4728 1.33301 8.00004 1.33301Z",
    fill: "#99A2AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40012 7.99967C3.03256 7.99967 2.74554 8.32344 2.83805 8.67917C3.38578 10.7854 5.1885 12.3854 7.40004 12.633V14.0663C7.40004 14.3977 7.66867 14.6663 8.00004 14.6663C8.33141 14.6663 8.60004 14.3977 8.60004 14.0663V12.633C10.8116 12.3854 12.6143 10.7854 13.162 8.67917C13.2545 8.32344 12.9675 7.99967 12.6 7.99967C12.3002 7.99967 12.0494 8.21903 11.9644 8.50653C11.4587 10.2177 9.87517 11.4663 8.00004 11.4663C6.12492 11.4663 4.54143 10.2177 4.03567 8.50653C3.9507 8.21903 3.69991 7.99967 3.40012 7.99967Z",
    fill: "#99A2AD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupMicOn);
export default __webpack_public_path__ + "static/media/group_mic_on.8d7a1e6ef7e1be1e1f091b2c7a2fb342.svg";
export { ForwardRef as ReactComponent };